import React from 'react'
import assets from 'xui/assets'
import CommonLogo, { ICommonLogoOptionalProps } from './CommonLogo'

// const LOGO = require('../img/about/logo_shopee.png')
const LOGO = assets.images.logo.shopee

const ShopeeLogo = (props: ICommonLogoOptionalProps) => <CommonLogo source={LOGO} {...props} />

export default ShopeeLogo
